export enum CustomStatusTableConfigEnum {
    ReturnData = 0,
    CheckFirstCharacter = 1,
    AnyInput = 2,
    SplitCSVAndApplyIfExists = 3,
}